<template>
  <div class="qw-products">
    <GridPanelHeader
      title=""
      :grid-ref="$refs.qwProductGrid"
      :show-add="true"
      :show-filter="false"
      :show-export="false"
      :show-columns="false"
      @add="handleAddClick"
    />
    <DxDataGrid
      :data-source="localData.products"
      :show-borders="true"
      :show-column-lines="true"
      :column-auto-width="true"
      :hover-state-enabled="true"
      :repaint-changes-only="true"
      :row-alternation-enabled="true"
      ref="qwProductGrid"
      :element-attr="gridAttributes"
      @editing-start="onEditingStart"
      @cell-prepared="onCellPrepared"
      key-expr="uuid"
    >
      <DxColumn dataField="name" :caption="$t('common.product')" :allowEditing="false">
        <DxRequiredRule :message="$t('validation.field_is_required')" />
      </DxColumn>
      <DxColumn dataField="code" :caption="$t('stock_management.products.code')" :allowEditing="false" />
      <DxColumn
        dataField="quantity_limit"
        :caption="$t('scale.quantity_warnings.quantity_limit')"
        data-type="number"
        :allowEditing="true"
      >
        <DxRequiredRule :message="$t('validation.field_is_required')" />
        <DxCustomRule :validationCallback="(e) => e.value >= 1" :message="$t('validation.min_value', { min: 1 })" />
      </DxColumn>
      <DxColumn dataField="measure_unit" :caption="$t('common.measure_unit')" :allowEditing="false" />

      <DxEditing mode="cell" :allowUpdating="true" :allowAdding="false" :allowDeleting="true" :use-icons="true">
        <DxTexts
          :confirm-delete-message="$t('common.confirm_delete', { title: $t('common.product') })"
          :confirm-delete-title="$t('common.confirm_delete_title')"
          :save-row-changes="$t('common.save')"
          :cancel-row-changes="$t('common.close')"
          :addRow="$t('common.add_new')"
          :editRow="$t('common.edit')"
          :deleteRow="$t('common.delete')"
        />
      </DxEditing>
      <DxHeaderFilter :visible="false" />
      <DxFilterRow :visible="false" />
      <DxSelection mode="single" />
    </DxDataGrid>

    <ProductSelector
      ref="productSelector"
      :visible="showProductDialog"
      @close="showProductDialog = false"
      @continue="onContinueFromProductSelector"
      :multiselect="true"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import DxDataGrid, {
  DxColumn,
  DxEditing,
  DxHeaderFilter,
  DxFilterRow,
  DxSelection,
  DxTexts,
  DxRequiredRule,
  DxCustomRule,
} from "devextreme-vue/data-grid";
import ProductSelector from "@/components/ProductSelector.vue";
import GridPanelHeader from "@/components/DxGrid/GridPanelHeader.vue";

export default {
  name: "QuantityWarningProducts",
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      gridAttributes: {
        class: "smagria-grid qw-product-grid",
      },
      localData: { ...this.formData },
      showProductDialog: false,
    };
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxHeaderFilter,
    DxFilterRow,
    DxSelection,
    DxTexts,
    DxRequiredRule,
    DxCustomRule,
    ProductSelector,
    GridPanelHeader,
  },
  methods: {
    ...mapActions({}),
    validate() {
      this.$refs.qwProductGrid.instance.saveEditData();
      if (!this.localData.products || !this.localData.products.length) {
        return [this.$t("validation.products_and_quantity_required")];
      }
      if (this.localData.products.some((p) => !p.quantity_limit || p.quantity_limit === 0)) {
        return [this.$t("validation.products_and_quantity_required")];
      }
      return [];
    },
    updateData(newData) {
      if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
        this.localData = { ...newData };
      }
    },
    handleAddClick() {
      this.showProductDialog = true;
    },
    onContinueFromProductSelector(selectedProducts) {
      selectedProducts.forEach((product) => {
        if (!this.localData.products.some((p) => p.product_uuid === product.uuid)) {
          this.localData.products.push({
            uuid: product.uuid,
            product_uuid: product.uuid,
            name: product.name,
            quantity_limit: 1,
            code: product.code,
            measure_unit: product.measure_unit?.name || "",
            measure_unit_id: product.measure_unit?.id || null,
          });
        }
      });
      this.showProductDialog = false;
    },
    onEditingStart() {},
    onCellPrepared(e) {
      if (e.rowType === "data" && e.column.allowEditing) {
        e.cellElement.classList.add("editable-cell-yellow");
      }
    },
  },
  watch: {
    formData: {
      deep: true,
      handler(newData) {
        if (JSON.stringify(this.localData) !== JSON.stringify(newData)) {
          this.localData = { ...newData };
        }
      },
    },
    localData: {
      deep: true,
      handler(newData) {
        this.$emit("input", newData);
      },
    },
  },
};
</script>
<style scoped>
.qw-product-grid {
   height: 100%;
}   

</style>